"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Theme_1 = __importDefault(require("../../Theme"));
const circleCancel_1 = __importDefault(require("../Icons/circleCancel"));
const circleSelected_1 = __importDefault(require("../Icons/circleSelected"));
const YesNo = (props) => {
    const [value, setValue] = react_1.useState(props.answer);
    const handleYesClick = () => {
        if (value === true) {
            setValue(null);
        }
        else {
            setValue(true);
        }
    };
    const handleNoClick = () => {
        if (value === false) {
            setValue(null);
        }
        else {
            setValue(false);
        }
    };
    react_1.useEffect(() => {
        props.onChange(value);
    }, [value]);
    react_1.useEffect(() => {
        setValue(props.answer);
    }, [props.answer]);
    return (react_1.default.createElement("span", { className: props.className },
        react_1.default.createElement(circleCancel_1.default, { "data-testid": "no_icon", onClick: handleNoClick, style: { color: value === false ? "red" : Theme_1.default.palette.secondary.main }, fontSize: props.fontSize ? props.fontSize : "default" }),
        react_1.default.createElement("span", { className: "yes_no_divider", style: { display: "inline-block", width: props.iconSeparation } }),
        react_1.default.createElement(circleSelected_1.default, { "data-testid": "yes_icon", onClick: handleYesClick, style: { color: value === true ? "green" : Theme_1.default.palette.secondary.main }, fontSize: props.fontSize })));
};
YesNo.defaultProps = {
    answer: undefined,
    value: null,
    fontSize: "default",
};
exports.default = YesNo;
//# sourceMappingURL=index.js.map